import React from 'react';
import { Step } from 'react-joyride';
// import { Trans } from 'react-i18next';
import i18n from '../../../translation/i18n';
import { StepTextContent } from '../../../components/app/onboarding/steps/step-text-content';
import { ImportTradesLastContent } from '../../../components/app/onboarding/steps/add-trades/import-trades-last-content';

// Useful arguments:
//
// spotlightClicks - clickable target
// hideFooter - hide buttons
// disableOverlay
// hideCloseButton
// disableScrolling
// showSkipButton

export const addTradesImportSteps: Step[] = [
    {
        target: '#import-trade-button',
        placement: 'bottom',
        disableBeacon: true,
        disableOverlayClose: true,
        disableScrolling: true,
        hideBackButton: false,
        spotlightClicks: false,
        hideFooter: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.import.step01', { returnObjects: true })} />
        ),
    },
    {
        target: '#select-platform',
        placement: 'bottom',
        showSkipButton: false,
        disableBeacon: true,
        disableScrolling: true,
        disableOverlayClose: true,
        hideBackButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.import.step02', { returnObjects: true })} />
        ),
    },
    {
        target: '#import-guide-button',
        placement: 'bottom',
        showSkipButton: false,
        disableBeacon: true,
        disableScrolling: true,
        disableOverlayClose: true,
        hideBackButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.import.step03', { returnObjects: true })} />
        ),
    },
    {
        target: '#import-confirm-button',
        placement: 'top',
        showSkipButton: false,
        disableBeacon: true,
        disableOverlayClose: true,
        hideFooter: false,
        disableScrolling: true,
        spotlightClicks: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.import.step04', { returnObjects: true })} />
        ),
    },
    {
        target: 'body',
        placement: 'center',
        showSkipButton: false,
        disableBeacon: true,
        disableScrolling: true,
        disableOverlayClose: false,
        hideFooter: false,
        hideBackButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.import.step05', { returnObjects: true })} />
        ),
    },
    {
        target: 'body',
        placement: 'center',
        showSkipButton: false,
        disableBeacon: true,
        disableScrolling: true,
        disableOverlayClose: true,
        hideFooter: false,
        hideBackButton: false,
        content: <ImportTradesLastContent />,
    },
];
